import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useEffect } from 'react';
import { ForegroundReconciler } from './ForegroundReconciler';

export const ForegroundReconcilerListener: React.FC = () => {
    const reconciler = useInstance(ForegroundReconciler);
    useEffect(() => {
        reconciler.start();
    }, [reconciler]);
    return null;
};
